import { Dropdown, Option } from "@fluentui/react-components";
import React, { useCallback } from "react";
import { ResetAll } from "./ResetAll";
import { TimezoneDropDown } from "./TimezoneDropdown";
import { observer } from "mobx-react";
import { useGlobalSetting } from "Store/GlobalSettingStore";
import { useStyles } from "./AppMenuSetting.styles";
import { AppMenuSovSimulationToggle } from "./AppMenuSovSimulationToggle";
import { OptionOnSelectData, SelectionEvents } from "Shared/FluentUIUnstableDef";

const AppMenuSettingBase = () => {
    const themeStore = useGlobalSetting("theme");
    const classNames = useStyles();

    const onChangeTheme = useCallback(
        (_event: SelectionEvents, data: OptionOnSelectData) => {
            if (data.optionValue === "dark") {
                themeStore.setThemeMode(true);
            } else if (data.optionValue === "light") {
                themeStore.setThemeMode(false);
            } else {
                themeStore.setThemeMode(undefined);
            }
        },
        [themeStore]
    );

    const systemModeText = themeStore.systemPrefersDark ? "Dark" : "Light";

    return (
        <div className={classNames.root}>
            <AppMenuSovSimulationToggle />
            <div className={classNames.container}>
                <div className={classNames.text}>Dark mode</div>
                <div className={classNames.dropdownContainer}>
                    <Dropdown className={classNames.dropdown} onOptionSelect={onChangeTheme} value={themeStore.themeLabel} aria-label="Dark mode">
                        <Option key="system" value="system" text="System">
                            <div className={classNames.timezoneLine}>
                                <span className={classNames.timezoneName}>System</span>
                                <span className={classNames.timezoneClock}>{systemModeText}</span>
                            </div>
                        </Option>
                        <Option key="light" value="light" text="Light">
                            Light
                        </Option>
                        <Option key="dark" value="dark" text="Dark">
                            Dark
                        </Option>
                    </Dropdown>
                </div>
            </div>
            <div className={classNames.container}>
                <TimezoneDropDown />
            </div>
            <div className={classNames.resetContainer}>
                <ResetAll />
            </div>
        </div>
    );
};

export const AppMenuSetting = observer(AppMenuSettingBase);
